import React, { useState } from 'react'
import { layerManage, showLayer } from '@/utils/layer'
import { createUseStyles } from 'react-jss'
import { Row } from '@/components/layout/layout'
import { Switch, Spin, Popover, message } from 'antd'
import { BaseRadio } from '@/components/base-radio/base-radio'
import { $post } from '@/api'
import { useRequest } from 'ahooks'
import $msg from '@/utils/message'
import { Modal } from '@/components/dialog/modal'
import { shopStore } from '@/store/shop'

const styles = createUseStyles({
    content: {
        margin: '8px',
    },

    item: {
        height: '50px',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    },

    item1: {
        height: '50px',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
})

interface IProps {}

export const GoodsRecordDialog: React.FC<IProps> = () => {
    const classes = styles()
    const [negativeStockMode, setNegativeStockMode] = useState(0) // 0 不允许负库存销售 2 允许负库存销售
    const [stockDeductionMode, setStockDeductionMode] = useState(0) // 0 付款减库存 1 拍下减库存
    const [isScaleMode, setIsScaleMode] = useState(false) // 条码秤模式
    const [isAutoScaleMode, setIsAutoScaleMode] = useState(false) // 条码秤序号自动生成

    const getGoodsProfile = () => {
        return $post({
            url: '/goods/getshopgoodsprofile',
        }).then(res => {
            setNegativeStockMode(res.profile.negative_stock_mode)
            setStockDeductionMode(res.profile.stock_deduction_mode)
            setIsScaleMode(res.profile.is_scale_mode)
            setIsAutoScaleMode(res.profile.is_auto_scale_num)
        })
    }
    const { loading } = useRequest(getGoodsProfile)

    const sumbmit = () => {
        $post({
            url: '/goods/updateshopgoodsprofile',
            params: {
                negative_stock_mode: negativeStockMode,
                stock_deduction_mode: stockDeductionMode,
                is_scale_mode: isScaleMode,
                is_auto_scale_num: isAutoScaleMode,
            },
        }).then(() => {
            $msg('success', '设置成功')
            // 更新全局接口
            $post({
                url: '/shop/getshopinfo',
            })
                .then(data => {
                    shopStore.setShopInfo(data)
                })
                .catch(e => {
                    $msg('error', e.message)
                })
        })
    }

    const batchCreateBarcode = () => {
        showLayer(
            <Modal
                headerStyles={{ width: '440px' }}
                isShow
                type="danger"
                style={{ height: '156px' }}
                onClose={() => layerManage.pop()}
                onCancel={() => layerManage.pop()}
                onConfirm={() => {
                    layerManage.pop()
                    const hide = message.loading('处理中...', 0, undefined)
                    $post({
                        url: '/goods/genallgoodsscalenum',
                    })
                        .then(() => {
                            hide()
                            $msg('success', '操作成功！')
                        })
                        .catch(e => {
                            hide()
                            $msg('error', e.message)
                        })
                }}
            >
                <div data-center data-font-size-16>
                    确认后，系统会自动给所有上架货品的所有售价生成条码秤序号
                </div>
            </Modal>,
        )
    }

    return (
        <Modal
            type="success"
            headerStyles={{ width: '480px' }}
            isShow
            title="商品档案设置"
            okText="保存设置"
            onClose={() => layerManage.pop()}
            onCancel={() => layerManage.pop()}
            onConfirm={() => {
                layerManage.pop()
                sumbmit()
            }}
        >
            <Spin spinning={loading}>
                <div className={classes.content}>
                    <Row className={classes.item}>
                        <span data-color-000 data-font-weight-600 data-font-size-14>
                            默认允许商品库存为负
                        </span>
                        <Switch
                            checked={negativeStockMode === 2}
                            onChange={() => setNegativeStockMode(negativeStockMode === 0 ? 2 : 0)}
                        ></Switch>
                    </Row>
                    <Row className={classes.item}>
                        <span data-color-000 data-font-weight-600 data-font-size-14>
                            默认库存扣减方式
                        </span>
                        <div>
                            <BaseRadio
                                value={0}
                                label={stockDeductionMode}
                                onChange={() => {
                                    setStockDeductionMode(0)
                                }}
                            >
                                <Popover title="适用于促销商品或热卖商品可避免超卖"> 付款减库存 </Popover>
                            </BaseRadio>
                            <BaseRadio
                                value={1}
                                label={stockDeductionMode}
                                onChange={() => {
                                    setStockDeductionMode(1)
                                }}
                                style={{ marginLeft: '10px' }}
                            >
                                <Popover title="适用于库存充足的情况，可减少恶拍，提高回款效率，存在超卖风险">
                                    {' '}
                                    拍下减库存{' '}
                                </Popover>
                            </BaseRadio>
                        </div>
                    </Row>
                    <Row className={classes.item}>
                        <span data-color-000 data-font-weight-600 data-font-size-14>
                            条码秤模式
                        </span>
                        <Switch
                            checked={isScaleMode}
                            onChange={() => {
                                setIsScaleMode(!isScaleMode)
                                setIsAutoScaleMode(!isScaleMode ? true : false)
                            }}
                        ></Switch>
                    </Row>
                    {isScaleMode && (
                        <Row className={classes.item1}>
                            <span data-color-000 data-font-weight-600 data-font-size-14>
                                条码秤序号自动生成
                            </span>
                            <Switch
                                checked={isAutoScaleMode}
                                onChange={() => {
                                    isScaleMode && setIsAutoScaleMode(!isAutoScaleMode)
                                }}
                            ></Switch>
                        </Row>
                    )}
                    {isScaleMode && (
                        <Row className={classes.item1} data-margin-bottom-16>
                            <span data-color-000 data-font-weight-600 data-font-size-14>
                                批量生成条码秤序号
                            </span>
                            <span style={{ cursor: 'pointer' }} data-color-blue onClick={batchCreateBarcode}>
                                生成
                            </span>
                        </Row>
                    )}
                </div>
            </Spin>
        </Modal>
    )
}
